import React from "react";

import img1 from "../assets/img2.jpeg";
import img2 from "../assets/img3.jpeg";
import img3 from "../assets/img4.jpeg";
import img4 from "../assets/img5.jpeg";

const slides = [
  {
    image: img1,
    title: "Diwali Mega Sale 2026",
    subtitle: "Big savings on all popular crackers — limited time!",
  },
  {
    image: img2,
    title: "Festival Special Offers",
    subtitle: "Exciting discounts across categories",
  },
  {
    image: img3,
    title: "Wholesale & Retail",
    subtitle: "Bulk rates for shops and events",
  },
  {
    image: img4,
    title: "Safe & Trusted",
    subtitle: "Sivakasi quality with safety assurance",
  },
];

const HeroSlider = () => {
  return (
    <div
      id="heroCarousel"
      className="carousel slide carousel-fade mb-4"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      {/* Dynamic Mobile/Desktop Height Controller Custom CSS Style Tag */}
      <style>
        {`
          .responsive-hero-img {
            height: 400px;
          }
          @media (max-width: 768px) {
            .responsive-hero-img {
              height: 220px !important; 
            }
            .responsive-hero-img + div h1 {
              font-size: 1.6rem !important;
            }
            .responsive-hero-img + div p {
              font-size: 0.9rem !important;
            }
          }
        `}
      </style>

      {/* Indicators */}
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
            aria-current={index === 0 ? "true" : undefined}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Slides */}
      <div className="carousel-inner rounded-4 overflow-hidden shadow">

        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <div className="position-relative">

              <img
                src={slide.image}
                alt={slide.title}
                className="d-block w-100 responsive-hero-img"
                style={{
                  objectFit: "cover",
                }}
              />

              {/* Overlay */}
              <div className="carousel-caption-custom position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center text-white px-3"
                style={{
                  background: "rgba(0,0,0,0.45)",
                }}
              >
                <h1 className="display-4 fw-bold">
                  {slide.title}
                </h1>

                <p className="lead">
                  {slide.subtitle}
                </p>
              </div>

            </div>
          </div>
        ))}

      </div>

      {/* Previous Button */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="prev"
      >
        <span
          className="carousel-control-prev-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Previous</span>
      </button>

      {/* Next Button */}
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#heroCarousel"
        data-bs-slide="next"
      >
        <span
          className="carousel-control-next-icon"
          aria-hidden="true"
        ></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default HeroSlider;